<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ coHolderTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ coHolderSubtitle | translate }}
            </p>
        </div>

        <form class="list" [formGroup]="formGroup">
            <div
                id="a"
                *ngFor="let coHolderOption of coHolderOptions"
                class="feature-box"
                [ngClass]="{ 'feature-box-selected': coHolderOption.key === this.formGroup.controls.selectedCoHolderOption.value }"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
                (click)="onChangeCoHolderSelection(coHolderOption)"
            >
                <div class="list-feature-text-box">
                    <label [for]="coHolderOption.key" class="text-paragraph-title">{{ coHolderOption.option | translate }}</label>
                    <label [for]="coHolderOption.key" class="text-paragraph">{{ coHolderOption.description | translate }}</label>
                </div>
                <div>
                    <p-radioButton
                        [inputId]="coHolderOption.key"
                        [value]="coHolderOption.key"
                        formControlName="selectedCoHolderOption"
                    ></p-radioButton>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
